import { useAuth } from '@/stores/authStore'
import { useCallback } from 'react'

/**
 * Hook for checking user permissions.
 * Provides a clean API for component-level permission checks.
 */
export function usePermission() {
  const { can: authCan, user } = useAuth()

  const can = useCallback((permission: string) => {
    return authCan(permission)
  }, [authCan])

  const hasAny = useCallback((permissions: string[]) => {
    return permissions.some(p => authCan(p))
  }, [authCan])

  const hasAll = useCallback((permissions: string[]) => {
    return permissions.every(p => authCan(p))
  }, [authCan])

  return {
    can,
    hasAny,
    hasAll,
    user,
    // Provide some common shortcuts
    isAdmin: user?.is_admin || user?.role === 'Super Admin' || user?.role_name === 'Super Admin',
    isSuperAdmin: user?.role === 'Super Admin' || user?.role_name === 'Super Admin'
  }
}
